<template>
  <div>
    <div class="text-body1 text-dark-200 text-center my-2">
      <img src="../../assets/img/ic_security.svg?url" alt="" /> {{ t('paySafe') }}
    </div>
    <div class="text-center">
      <img class="w-[250px]" src="../../assets/img/pay-safe.png" width="415" alt="" />
    </div>

    <div class="text-overline text-dark-100 font-medium text-start mt-2 mb-28">
      <p v-if="authFeeText" class="mb-2">{{ authFeeText }}</p>
      {{
        t('hint', {
          label: packageSelected?.label ?? '',
          packageSelectedPriceFormatted,
          packageSelectedPriceNextFormatted,
          discount,
        })
      }}
      <a
        class="text-overline text-dark-200 font-medium underline"
        href="mailto:support@meetmyage.com"
        >support@meetmyage.com</a
      >. {{ t('see') }}
      <a
        class="text-overline text-dark-200 font-medium underline"
        href="#"
        @click.prevent="emit('show-membership')"
        >{{ t('policy') }}</a
      >
      {{ t('forDetails') }}.
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PaymentStatePackagePremium } from '@/pages/payment/store/payment-state';
import { useI18n } from '@/services/i18n';

import { messages } from './i18n';

defineProps<{
  packageSelected: PaymentStatePackagePremium;
  packageSelectedPriceFormatted: string;
  packageSelectedPriceNextFormatted: string;
  discount: string;
  authFeeText: string;
}>();

const emit = defineEmits<{
  (e: 'show-membership'): void;
}>();

const { t } = useI18n({ messages });
</script>
